<template>
  <div class="el-section">
    <anticipation-details></anticipation-details>
  </div>
</template>

<script>
import '@pagarme/anticipation-details/web-comp'

export default {
  name: 'AnticipationsDetails'
}
</script>
